import type { ReactElement } from "react";
import React from "react";
import { twMerge } from "tailwind-merge";

import type { FAQProps } from "../types.js";
import { FAQ } from "./FAQ.js";

/**
 * Support for the [rt-faqs-glossary] shortcode.
 *
 * @param props The props for the component.
 * @returns The component.
 */
export function Glossary(props: FAQProps): ReactElement {
	const newProps = {
		...props,
		show: true,
		class: twMerge(
			"faq:[&_.entry]:break-inside-avoid faq:[&_.entry]:rounded-xl faq:[&_.entry]:border faq:[&_.entry]:border-solid faq:[&_.entry]:border-site-500/25 faq:[&_.entry]:bg-white faq:[&_.entry]:p-8 faq:[&_.entry]:pb-4 faq:[&_.entry]:shadow faq:[&_.entry_dd]:mx-0 faq:[&_.entry_dt]:mt-0 faq:[&_.entry_dt]:mb-4 faq:[&_.entry_dt]:rounded-none faq:[&_.entry_dt]:border-0 faq:[&_.entry_dt]:bg-none faq:[&_dd]:ml-0",
		),
		alpha: false,
		hide_title: false,
		hide_accordion: true,
	};
	return <FAQ {...newProps} />;
}
